import { render, staticRenderFns } from "./order-return-file-upload.vue?vue&type=template&id=b7f1e966&"
import script from "./order-return-file-upload.vue?vue&type=script&lang=js&"
export * from "./order-return-file-upload.vue?vue&type=script&lang=js&"
import style0 from "./order-return-file-upload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports